module.exports = __webpack_public_path__ + "img/icon-物理@2x.f4aaa4df.png";